import { useQuery } from 'react-query'
import { getApiServer } from '../../utils/domain'
import request from 'superagent'

export default function useCsrfToken() {
    return useQuery('csrfToken', async () => {
        return request.get(getApiServer() + '/csrf-token')
            .set('Accept', 'application/json')
            .withCredentials()
            .then((res) => res.body)
    },
        {
            retry: false,
            staleTime: 30 * 60 * 1000,
            cacheTime: 60 * 60 * 1000,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchOnMount: false
        }
    )
}